/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-risk': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="#ff8c54"><path pid="0" d="M19.866 17.751L10.58.877a.69.69 0 0 0-1.21 0L.086 17.75a.69.69 0 0 0 .605 1.024h18.57a.69.69 0 0 0 .605-1.024zm-18.007-.358l8.117-14.75 8.116 14.75z"/><path pid="1" d="M9.11 7.577v4.991a.866.866 0 0 0 1.731 0V7.577a.866.866 0 0 0-1.73 0zM9.976 14.332a.913.913 0 0 0 0 1.823.913.913 0 0 0 0-1.823z"/></g>'
  }
})
